import { ShapeIcon, Typography } from "@flash-tecnologia/hros-web-ui-v2";
import * as SC from "./module-assessment.styles";
import { Question } from "bff/src/services";
import { Box, Checkbox } from "@/components/core-components";
import { getModuleProps } from "../../constants";
import { useEffect } from "react";
import { setPageTracking } from "@/utils";
import { TrackingPages } from "../../types";

interface ModuleAssessmentProps {
  question: Question;
  selectedOptions: string[];
  onSelectionChange: (selectedOption: string) => void;
}

export const ModuleAssessment: React.FC<ModuleAssessmentProps> = ({
  question,
  selectedOptions,
  onSelectionChange,
}) => {
  useEffect(() => {
    setPageTracking(TrackingPages.SETUP_MODULES_ASSESSMENT_WORKFLOW_PAGE);
  }, []);

  return (
    <SC.ResponsiveContainer>
      <Box $mb="s">
        <Typography.Headline8 color="neutral.20">
          Antes de começarmos, conta para a gente: quais dos produtos você irá
          configurar e gerenciar diretamente?
        </Typography.Headline8>
      </Box>
      <SC.Grid>
        {question?.options.map((option) => (
          <SC.GridItem
            key={option.value}
            $selected={selectedOptions.includes(option.value)}
            onClick={() => onSelectionChange(option.value)}
          >
            <Box justifyContent="space-between" $mb="xs2">
              <ShapeIcon
                name={getModuleProps(option.value).icon}
                variant="default"
                color="var(--color-secondary-50)"
                size={48}
              />
              <Checkbox checked={selectedOptions.includes(option.value)} />
            </Box>
            <Typography.Headline9 color="neutral.30">
              {option.text}
            </Typography.Headline9>
          </SC.GridItem>
        ))}
      </SC.Grid>
    </SC.ResponsiveContainer>
  );
};
